import { combineReducers, createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import sagas from './sagas';
import { reducerRegistry } from './reducerRegistry';

const combine = reducers => {
  Object.keys(reducers).forEach(key => {
    if (typeof reducers[key] === 'object') {
      // eslint-disable-next-line no-param-reassign
      reducers[key] = combine(reducers[key]);
    }
  });
  if (Object.keys(reducers).length > 0) {
    return combineReducers(reducers);
  }
  return combineReducers({});
};

export const sagaMiddleware = createSagaMiddleware();
const reducer = combine(reducerRegistry.getReducers());
// Создаем первичное состояние store.
const store = createStore(
  reducer,
  composeWithDevTools(applyMiddleware(sagaMiddleware))
);
// Запускаем все объявленные саги
sagaMiddleware.run(sagas);

// Заменяем reducers после любого изменения структуры, например при добавлении,
// удалении динамичиских редукторов
reducerRegistry.setChangeListener(reducers => {
  store.replaceReducer(combine(reducers));
});

export default store;



// WEBPACK FOOTER //
// ./src/mt-react-common/createStore.js